import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { SettingsService } from '@toro/common/shared/services/settings/settings.service';
import { StorageService } from '@toro/common/shared/services/storage.service';
import { BrokerageModel } from '@toro/common/shared/enum/billing/brokerage-model.enum';

@Injectable()
export class CheckoutStockGuard implements CanActivate, CanLoad {

    private user: any = null;
    private stockCheckoutItem: any = null;
    private usingZeroModel: boolean = false;

    constructor(
        private store: Store<AppState>,
        private settingsService: SettingsService,
        private router: Router,
    ) {
        this.store.select((s) => s.authentication.currentUser)
            .subscribe((data) => this.user = data);
        this.store.select((s) => s.exchangeCheckout.stockCheckout)
            .subscribe((data) => this.stockCheckoutItem = data);
    }

    // Método de Interface
    public canActivate() {
        return this.validateCheckoutParameter();
    }

    public canLoad(route: Route) {
        return this.validateCheckoutParameter();
    }

    private validateCheckoutParameter() {

        if (this.user) {
            if (this.stockCheckoutItem) {
                return true;
            } else {
                this.router.navigateByUrl('/investir');
                return false;
            }
        } else {
            location.href = this.settingsService.getConfigurationKeyValue('rau');
            return false;
        }
    }
}
